module.exports = __webpack_public_path__ + "static/media/la-picture-2.4731667a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/la-picture-2.jpg
// module id = 570
// module chunks = 0